import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import Loader from '../../../../components/Feedback/Loader';
import { fetchData } from '../../../../services/fetch';
import FormEditSimple from './Form';

export default function QuestionnaireSimpleEdit() {
 const { id: surveyId } = useParams();

 const { data, isLoading, mutate } = useSWR(
  surveyId ? `/survey/${surveyId}` : null,
  fetchData
 );

 let defaultValues;

 if (data) {
  defaultValues = {
   name: data.survey?.description || '',
   questions: data?.questions || [],
  };
 }

 if (isLoading || !defaultValues) {
  return <Loader />;
 }

 return (
  <FormEditSimple
   defaultValues={defaultValues}
   replicable={data?.survey?.replica_type || 'non-replicable'}
   mutate={mutate}
   surveyId={surveyId}
  />
 );
}
